const languageData = [
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Español',
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
  },
];
export default languageData;
